import { UnauthenticatedHttpClient } from '../../httpClient/unauthenticatedHttpClient'

export const logout = async (): Promise<void> => {
  window.top?.localStorage.removeItem('accessToken')
  window.top?.localStorage.removeItem('accessTokenExpires')

  const client = UnauthenticatedHttpClient()

  try {
    const result = await client.delete('/login')
    if (result.status) {
      window.top?.location.assign(result.data.destination)
    }
  } catch {
    window.top?.location.assign('/login')
  }
}
